<div *ngIf="notification" 
     [ngClass]="{
      'bg-primary': notification.type == 'success',
      'bg-[#F52237]': notification.type == 'error',
      'bg-graymabe': notification.type == 'warning',
     }" 
     class="fixed bottom-5 right-0 mx-[2.5%] p-4 flex items-center w-[95%] md:max-w-[700px] md:w-fit justify-between text-white rounded-lg shadow-lg transition-opacity z-[999]">
  <span>{{ notification.message }}</span>
  <button (click)="close()" class="ml-4 text-xl leading-none focus:outline-none">&times;</button>
</div>
